import Anthropic from '@anthropic-ai/sdk';

let client = null;

function getClient() {
  if (!client) {
    const apiKey = import.meta.env.VITE_ANTHROPIC_API_KEY;
    if (!apiKey || apiKey === 'your-api-key-here') {
      return null;
    }
    client = new Anthropic({ apiKey, dangerouslyAllowBrowser: true });
  }
  return client;
}

export function isLLMAvailable() {
  const apiKey = import.meta.env.VITE_ANTHROPIC_API_KEY;
  return apiKey && apiKey !== 'your-api-key-here';
}

export async function generateSummary(parcelInfo, regulations) {
  const anthropic = getClient();
  if (!anthropic) {
    throw new Error('Anthropic API key niet geconfigureerd');
  }

  const regulationText = regulations
    .map((r) => `- ${r.title}: ${r.summary}`)
    .join('\n');

  const prompt = `Je bent een adviseur voor Nederlandse akkerbouwers. Geef een beknopte, praktische samenvatting in het Nederlands van de regelgeving die van toepassing is op dit landbouwperceel.

Perceelinformatie:
- Gewas: ${parcelInfo.crop}
- Oppervlakte: ${parcelInfo.area}
- Locatie: nabij ${parcelInfo.overlaps.join(', ')}

Van toepassing zijnde regelgeving:
${regulationText}

Geef een samenvatting in 3-5 zinnen met concrete actiepunten voor de agrariër. Gebruik duidelijke, toegankelijke taal.`;

  const message = await anthropic.messages.create({
    model: 'claude-haiku-4-5-20251001',
    max_tokens: 500,
    messages: [{ role: 'user', content: prompt }],
  });

  return message.content[0].text;
}
